module.exports = __webpack_public_path__ + "img/logo.d1c10394.png";